// Module
var code = "<div> <p>Please select component:</p> <div class=\"select-container copy-properties\"></div> </div> ";
// Exports
export default code;